import React from 'react';
import { Form, InputGroup } from "react-bootstrap";
import Image from 'react-bootstrap/Image';
import Search from "../../assets/images/search-line.svg";

const SearchBar = () => {
    return (
        <>
            <InputGroup className="border bg-white" style={{border: "solid 1px #e4e4e4",}}>
                <Image style={styles.image1} className="d-inline border-0 my-auto mx-2" src={Search} fluid />
                <Form.Control className="border-0 shadow-none ps-0" style={styles.text1} type="text" placeholder="Search" />
            </InputGroup>
        </>
    );
}

const styles: any= {
    image1: {
        width: "24px",
        height: "24px",
      },
      text1: {
        fontFamily: "Saira",
        fontSize: "16px",
        color: "#6d6e71",
      },
};

export default SearchBar;
